import { render, staticRenderFns } from "./zxzfList.vue?vue&type=template&id=231913d0&scoped=true"
import script from "./zxzfList.vue?vue&type=script&lang=js"
export * from "./zxzfList.vue?vue&type=script&lang=js"
import style0 from "./zxzfList.vue?vue&type=style&index=0&id=231913d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231913d0",
  null
  
)

export default component.exports